import React from 'react';
import { merge } from 'lodash-es';
import { ThemeProvider as BaseThemeProvider } from 'styled-components';
import baseTheme from './theme';

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var mergedTheme = mergeTheme(theme);
  return /*#__PURE__*/React.createElement(BaseThemeProvider, {
    theme: mergedTheme
  }, children);
};

var mergeTheme = function mergeTheme(theme) {
  if (!theme) {
    return baseTheme;
  }

  if (typeof theme === 'function') {
    return theme(baseTheme);
  }

  return merge({}, baseTheme, theme);
};

export default ThemeProvider;